<template>
<v-menu offset-y top :close-on-content-click="false" v-model="menu">
            <template v-slot:activator="{ on, attrs }">
              <v-btn id="pfid1657730445" :loading="unsubscribing" text v-on="on" v-bind="attrs"><v-icon left>$unsubscribe</v-icon>{{$t('contacts.unsubscribe.quick.title')}}</v-btn>
            </template>
            <v-card style="width:400px">
              <v-card-title>{{$t('common.emailAddress')}}</v-card-title>
              <v-card-text>
                <v-text-field
                  id="pfid1657730690"  
                  v-model="email"
                  type="email"
                  append-outer-icon="$remove"
                  @click:append-outer="remove"
                />
              </v-card-text>
            </v-card>
        </v-menu>
</template>
<script>

export default {
    name: 'QuickUnsubscribe',
    data() {
        return {
            email: null,
            unsubscribing: null,
            menu: false
        }
    },
    props: { domain: String },
    methods: {
        async remove() {
            this.unsubscribing = true;
            let result = await this.$store.dispatch('imports/unsubscribe', { domainId: this.domain, email: this.email });
            this.unsubscribing = false;
            let not;
            if(result) {
                not = { text: this.$t(`contacts.unsubscribe.quick.success`, { email: this.email }) };
                this.$store.dispatch('domains/get', { id: this.domain });
            } else {
                not = { error: true, text: this.$t('contacts.unsubscribe.quick.error')};
            }
            this.$store.dispatch('ui/notify', not);
            
        }
    }
}
</script>

<style>

</style>